module.exports = __webpack_public_path__ + "static/media/correct-answer.a9a052d6.svg";